@if (content.pageTitle) {
  <div class="nsc-page-title">
    <h2>{{ content.pageTitle }} </h2>
    @if (content.pageTitle == 'Order a Transcript') {
      <div>
        <button mat-raised-button id="schoolselect_addprocess" color="primary" class="nsc-btn__right nsc-btn--small"
          type="button" (click)="redirectToProcessFlowLink()">Learn How the Process Works
          <mat-icon aria-hidden="true" >chevron_right</mat-icon></button>
        </div>
      }
      @if (content.recipient) {
        <p  ><strong>Send To:</strong> {{content.recipient}}</p>
      }
      <nsc-spacer size="md"></nsc-spacer>
    </div>
  }